import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import fp from 'lodash/fp';
import { toCurrency, getValue } from '@deerplusofficial/pos-helper';
import { discountOptionsShape } from '../../model/Types';
import actions from '../../actions';
import withSubtotal from '../../assist/withSubtotal';
import Modal from '../Modal/Modal';
import InfoSection from '../Info/InfoSection';
import Info from '../Info/Info';
import InfoWithCalculatorInput from '../InfoWithCalculatorInput/InfoWithCalculatorInput';
import Select from '../Select/Select';

class DiscountModal extends Component {
  static propTypes = {
    active: PropTypes.bool,
    subtotal: PropTypes.number,
    discountOptions: discountOptionsShape,
    orderDiscount: PropTypes.oneOfType([
      PropTypes.shape({
        type: PropTypes.number,
        formattedValue: PropTypes.string,
        name: PropTypes.string,
        id: PropTypes.string,
      }),
      PropTypes.shape({
        type: PropTypes.number,
        criteria: PropTypes.number,
        formattedValue: PropTypes.string,
      }),
    ]),
    editDiscount: PropTypes.func,
    onMainStateToggle: PropTypes.func,
  };

  static defaultProps = {
    active: false,
    subtotal: 0,
    discountOptions: [],
    orderDiscount: {},
    editDiscount: _.identity,
    onMainStateToggle: _.identity,
  };

  state = {
    discount: {},
  };

  componentDidMount() {
    return this.syncPropsDiscount();
  }

  componentDidUpdate(prevProps) {
    const { active } = this.props;

    if (prevProps.active === active || !active) return;

    return this.syncPropsDiscount();
  }

  syncPropsDiscount = () => {
    const { orderDiscount } = this.props;

    this.setState({ discount: orderDiscount });
  };

  onCalculatorRef = element => (this.calculator = element);

  onCalculatorKeyDown = e => this.calculator.onButtonPress(e);

  onPlanChange = e => {
    const { discountOptions } = this.props;
    const targetId = e.target.value;

    if (targetId === 'init') return this.setState({ discount: {} });

    const { id, name, formattedValue } = _.find(discountOptions, {
      id: targetId,
    });

    return this.setState({ discount: { id, name, formattedValue, type: 1 } });
  };

  onDiscountChange = formattedValue => {
    const criteria = /%/.test(formattedValue) ? 1 : 0;
    this.setState({
      discount: {
        criteria,
        formattedValue,
        type: 0,
      },
    });
  };

  onDiscountSave = () => {
    const { discount } = this.state;
    const { editDiscount, closeModal } = this.props;

    if (_.size(discount) === 0) return this.onDiscountRemove();

    editDiscount(discount);

    return closeModal();
  };

  onDiscountRemove = () => {
    const { editDiscount } = this.props;
    this.setState({ discount: {} });
    editDiscount({});
    closeModal();
  };

  get actions() {
    return {
      remove: {
        text: '移除折扣',
        callback: this.onDiscountRemove,
      },
      save: {
        text: '儲存',
        callback: this.onDiscountSave,
      },
    };
  }

  get plans() {
    const { discountOptions, subtotal } = this.props;
    const options = _.map(discountOptions, ({ name, id, base_amount }) => ({
      text: name,
      value: id,
      disabled: subtotal < base_amount,
    }));

    return [{ text: '未選擇折扣方案', value: 'init' }, ...options];
  }

  get discountPrice() {
    const { subtotal } = this.props;
    const { formattedValue } = this.state.discount;

    const discountValue = getValue(formattedValue);

    if (discountValue % 1 !== 0) return subtotal * discountValue;

    return discountValue;
  }

  get subtotalPrice() {
    const { subtotal } = this.props;

    if (subtotal <= this.discountPrice) return 0;

    return subtotal - this.discountPrice;
  }

  get currentPlan() {
    return _.get(this.state, ['discount', 'id'], 'init');
  }

  get customDiscount() {
    const { type, formattedValue } = this.state.discount;

    return type !== 0 ? '' : formattedValue;
  }

  render() {
    const { active, subtotal, closeModal } = this.props;

    return (
      <Modal
        title="設定訂單折扣"
        active={active}
        actions={this.actions}
        onToggleModal={closeModal}
      >
        <InfoSection>
          <Info label="訂單金額">{subtotal}</Info>
        </InfoSection>
        <InfoSection>
          <InfoWithCalculatorInput
            advanced
            showCalculator
            label="手動輸入折扣"
            onChange={this.onDiscountChange}
            displayValue={_.trim(`- ${this.customDiscount}`)}
            value={this.customDiscount}
          />
          <Info label="折扣方案">
            <Select
              noBorder
              value={this.currentPlan}
              options={this.plans}
              onChange={this.onPlanChange}
            />
          </Info>
        </InfoSection>
        <InfoSection>
          <Info label="折扣金額">{toCurrency(-this.discountPrice)}</Info>
          <Info label="小計">{toCurrency(this.subtotalPrice)}</Info>
        </InfoSection>
      </Modal>
    );
  }
}

const { edit: editDiscount } = actions.order.discount;
const { close: closeModal } = actions.discountModal;

export default fp.compose(
  withSubtotal(),
  connect(
    (
      { order, discountModal, products: { discountOptions } },
      { getSubtotal }
    ) => ({
      discountOptions,
      orderDiscount: order.discount,
      active: discountModal.active,
      subtotal: getSubtotal(true),
    }),
    { editDiscount, closeModal }
  )
)(DiscountModal);



// WEBPACK FOOTER //
// ./src/components/DiscountModal/DiscountModal.js